import {combineReducers} from 'redux';

import agent from './AgentReducer';
import reports from './ReportsReducer';
import utilities from './UtilitiesReducer';

export default combineReducers({
    agent,
    utilities,
    reports
});